import { render, staticRenderFns } from "./date-box.vue?vue&type=template&id=18675a68&scoped=true"
import script from "./date-box.vue?vue&type=script&lang=js"
export * from "./date-box.vue?vue&type=script&lang=js"
import style0 from "./date-box.vue?vue&type=style&index=0&id=18675a68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18675a68",
  null
  
)

export default component.exports